import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function getGbpCampaigns(locationId) {
  return axios.get(`/ajax/locations/${locationId}/gbp_campaigns`)
}

export function getGbpCampaign(id) {
  return axios.get(`/ajax/gbp_campaigns/${id}`)
}

export function createGbpCampaign(locationId, data) {
  return axios.post(`/ajax/locations/${locationId}/gbp_campaigns`, data)
}

export function destroyGbpCampaign(id) {
  return axios.delete(`/ajax/gbp_campaigns/${id}`)
}

export function exportGbpCampaign(id) {
  return axios.post(`/ajax/gbp_campaigns/${id}/export`)
}

export function sendAllForApproval(id, data = {}) {
  return axios.post(`/ajax/gbp_campaigns/${id}/send_all_for_approval`, { approval: data })
}
